import { useState } from 'react'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import {
  CardContent,
  Typography,
  CardActions,
  Button,
  Card,
} from '@mui/material'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import axios from 'src/utilities/http-client'

dayjs.extend(utc)

export default () => {
  let [date, setDate] = useState(dayjs(new Date()))
  let [submissionStatus, setSubmissionStatus] = useState<
    'unsubmitted' | 'submitting' | 'submitted'
  >('unsubmitted')

  let submit = () =>
    axios
      .post('/api/v2/admin/ce/live/resubmit', { date })
      .then(() => setSubmissionStatus('submitted'))
      .catch(() => setSubmissionStatus('unsubmitted'))

  return (
    <>
      <Card sx={{ p: 2 }}>
        <CardContent>
          <Typography sx={{ pb: 4 }} variant="body2" color="text.secondary">
            Send all Live Class CEs to CAPCE between a selected date and now.
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Start Date"
              value={date}
              onChange={(v) => setDate(v as dayjs.Dayjs)}
            />
          </LocalizationProvider>
        </CardContent>
        <CardActions>
          <Button
            disabled={submissionStatus !== 'unsubmitted'}
            variant="outlined"
            color="primary"
            fullWidth
            onClick={submit}
          >
            {submissionStatus === 'submitting'
              ? 'Submitting...'
              : submissionStatus === 'submitted'
                ? 'Submitted'
                : 'Submit'}
          </Button>
        </CardActions>
      </Card>
    </>
  )
}
